<template>
  <div class="wg-row">
    <customer-details :contact="contact" v-model="customerDetails"></customer-details>
    <div class="vertical-height-div" style="height: 15px"></div>
    <div class="wg-row">
      <input
        type="button"
        class="small"
        :style="{ opacity: canGenerateContract ? '' : '0.6' }"
        :disabled="!canGenerateContract"
        :value="
          $anm22.strLang(
            lang,
            'Save and generate license',
            'Salva e genera licenza'
          )
        "
        @click="save"
        data-cy=save-generate-license
      />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import { mapState } from "vuex";
import CustomerDetails from "./CustomerDetails.vue";

export default {
  components: {
    CustomerDetails
  },
  props: {
    projectId: [Number, String],
    contact: Object
  },
  data() {
    return {
      customerDetails: {}
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
      offline: (state) => state.offline.isOffline
    }),
    canGenerateContract() {
      let canGenerate = true;
      if (!this.customerDetails.name || this.customerDetails.name == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressStreet || this.customerDetails.addressStreet == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressCity || this.customerDetails.addressCity == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressZip || this.customerDetails.addressZip == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressState || this.customerDetails.addressState == "") {
        canGenerate = false;
      }
      if (!this.customerDetails.addressCountry || this.customerDetails.addressCountry == "") {
        canGenerate = false;
      }
      if (
        (!this.customerDetails.email || this.customerDetails.email == "") &&
        (!this.customerDetails.email2 || this.customerDetails.email2 == "") &&
        (!this.customerDetails.email3 || this.customerDetails.email3 == "")
      ) {
        canGenerate = false;
      }
      let phone1 = null;
      let phone2 = null;
      let phone3 = null;
      if (this.customerDetails.phoneAreaCode == "" || this.customerDetails.phoneNumber == "") {
        phone1 = null;
      } else {
        phone1 = this.customerDetails.phoneAreaCode + this.customerDetails.phoneNumber;
      }
      if (
        this.customerDetails.phoneAreaCode2 == "" ||
        this.customerDetails.phoneNumber2 == ""
      ) {
        phone2 = null;
      } else {
        phone2 = this.customerDetails.phoneAreaCode2 + this.customerDetails.phoneNumber2;
      }
      if (
        this.customerDetails.phoneAreaCode3 == "" ||
        this.customerDetails.phoneNumber3 == ""
      ) {
        phone3 = null;
      } else {
        phone3 = this.customerDetails.phoneAreaCode3 + this.customerDetails.phoneNumber3;
      }
      if (!phone1 && !phone2 && !phone3) {
        canGenerate = false;
      }
      return canGenerate;
    }
  },
  methods: {
    async save() {
      try {
        const response = await this.$http.post("spiagge/generate-license", {
            projectId: this.projectId,
            contact: this.contact,
            customerDetails: this.customerDetails
          },
          {
            withCredentials: true
          }
        );
        if (response) {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            }),
            this.$store.dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects
            })
          ])
            .then(() => {
              if (response.data.error) {
                this.$anm22.eventBus.$emit("world-headbar-show-message", {
                  text: this.$anm22.strLang(
                    this.lang,
                    "Failed contract generation",
                    "Generazione contratto fallita"
                  ),
                  type: "alarm"
                });
                this.$anm22.eventBus.$emit("wg-modal-close");
              } else {
                //Redirect pagina contratto
                window.open(response.data.url, "_blank");
                this.$anm22.eventBus.$emit("wg-modal-close");
              }
            });
        }
      } catch(e) {
        console.log(e);
      }
    }
  },
  created() {
    
  }
};
</script>
 
<style lang="scss" scoped>
.add {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-top: -3px;
  margin-left: 4px;
  cursor: pointer;
}
.input-row {
  padding: 0 5px;
  margin-bottom: 5px;
  align-items: center;
}
// .input-elem {

// }
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 16px;
  padding: 1px 2px;
  cursor: pointer;
}
.detail-row {
  flex-wrap: nowrap;
  align-items: center;
  margin-bottom: 10px;

  & img {
    margin: 0 30px 0 10px;
  }
}
</style>
 